export const selectCurrentModal = ({ core: { currentModal } }) => currentModal;
export const selectCurrentModalData = ({ core: { currentModalData } }) => currentModalData;

export default {
  selectCurrentModal,
  selectCurrentModalData,
};
